import { getIn } from 'formik';

export const showError = (form: any, byName: string) => !!form.submitCount && getIn(form.errors, byName);
